import {
  parseResultsReadSource,
  type ResultsReadSource,
} from '@breakoutlearning/firebase-repository/cubits/resultsReadSource'

// sessionStorage key holding the results read override. sessionStorage scopes
// it to one browser tab, so CX can compare the API and Firestore tables side by
// side in two tabs, and it clears when the tab closes. Absent = follow the
// readResultsFromApi feature flag.
const STORAGE_KEY = 'results-read-source'

export function getResultsReadSource(): ResultsReadSource | undefined {
  return parseResultsReadSource(sessionStorage.getItem(STORAGE_KEY))
}

export function setResultsReadSource(
  source: ResultsReadSource | undefined
): void {
  if (source) sessionStorage.setItem(STORAGE_KEY, source)
  else sessionStorage.removeItem(STORAGE_KEY)
}

// The CX button cycles: follow the flag -> force API -> force Firestore ->
// follow the flag.
export function nextResultsReadSource(
  current: ResultsReadSource | undefined
): ResultsReadSource | undefined {
  if (current === undefined) return 'api'
  if (current === 'api') return 'firestore'
  return undefined
}
